export default {
    namespaced: true,
    state: () => ({
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "regdate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        category: '0',
        statuses: [
            {category: '-1', value: '1' },
            {category: '0', value: new Date().getFullYear().toString() },
            {category: '1', value: new Date().getFullYear().toString() },
            {category: '2', value: new Date().getFullYear().toString() },
        ],
        tableSearchs: []
    }),
    mutations: {
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
        SET_CATEGORY (state, payload) {
            state.category = payload;
        },
        SET_STATUS (state, payload) {
            let exists = state.statuses.find(x => x.category == state.category);

            if (exists)
                exists.value = payload;
            else
                state.statuses.push({category:state.category, value:payload});
        },
        SET_TABLE_SEARCH (state, payload) {
            let exists = state.tableSearchs.find(x => x.category == state.category);

            if (exists)
                exists.value = payload;
            else
                state.tableSearchs.push({category:state.category, value:payload});
        }
    },
    getters: {
        GetTableOptions: (s) => s.tableOptions,
        GetCategory: (s) =>  s.category,
        GetStatus(state) {
            return state.statuses.find(x => x.category === state.category)?.value;
        },
        GetTableSearch(state) {
            return state.tableSearchs.find(x => x.category === state.category)?.value;
        }
    }
}